<template>
  <header class="ren-decoration-cp ren-decoration-cp-news-topbar">
    <div>
      <span>{{ location }}</span>
      <strong>{{ brandName }}</strong>
      <span>{{ notificationLabel }}</span>
    </div>
    <p>{{ searchPlaceholder }}</p>
    <nav>
      <span v-for="item in channels" :key="item">{{ item }}</span>
    </nav>
  </header>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { stringValue } from '../../../previews/preview-helpers'
import type { WidgetPreviewProps } from '../../types'

const props = defineProps<WidgetPreviewProps>()
const brandName = computed(() => stringValue(props.component.props?.brandName, '新聚浪'))
const location = computed(() => stringValue(props.component.props?.location))
const searchPlaceholder = computed(() => stringValue(props.component.props?.searchPlaceholder, '搜索'))
const notificationLabel = computed(() => stringValue(props.component.props?.notificationLabel, '消息'))
const channels = computed(() =>
  stringValue(props.component.props?.channels)
    .split(',')
    .map((item) => item.trim())
    .filter(Boolean)
)
</script>

<style scoped>
.ren-decoration-cp-news-topbar {
  display: grid;
  gap: 8px;
  padding: 11px 12px 12px;
  border-radius: var(--ren-theme-radius);
  background: var(--ren-theme-primary);
  color: var(--ren-theme-on-primary, #fff);
}
.ren-decoration-cp-news-topbar div,
.ren-decoration-cp-news-topbar nav {
  display: flex;
  gap: 12px;
}
.ren-decoration-cp-news-topbar span,
.ren-decoration-cp-news-topbar p {
  margin: 0;
  color: inherit;
  opacity: 0.9;
  font-size: 12px;
}
.ren-decoration-cp-news-topbar strong {
  color: inherit;
}
</style>
